const state = {
  sidebar: false,
  sidebarMini: false,
};

// getters
const getters = {
  sidebarIsOpen: state => {
    return state.sidebar === true;
  },
  sidebarMini: state => {
    return state.sidebarMini === true;
  },
};

// actions
const actions = {
  toggleSidebar({ commit }) {
    commit('toggleSidebar');
  },
  setSidebarIsOpen({ commit }, isOpen) {
    commit('setSidebarIsOpen', isOpen);
  },
  toggleSidebarMini({ commit }) {
    commit('toggleSidebarMini');
  },
};

// mutations
const mutations = {
  toggleSidebar(state) {
    state.sidebar = !state.sidebar;
  },
  setSidebarIsOpen(state, isOpen) {
    state.sidebar = isOpen;
  },
  toggleSidebarMini(state) {
    state.sidebarMini = !state.sidebarMini;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
